import React from "react";
import { getCurrentUser, signInWithRedirect } from "aws-amplify/auth";
import PropTypes from "prop-types";
class Authenticator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
    };
  }

  async componentDidMount() {
    getCurrentUser()
      .then(() => {
        this.setState({
          loggedIn: true,
        });
      })
      .catch((err) => {
        console.error(err);
        try {
          this.tryLogin().then();
        } catch {
          console.log("failed");
        }
      });
  }

  async tryLogin() {
    await signInWithRedirect();
  }

  render() {
    if (this.state.loggedIn) {
      return this.props.children;
    }
    return <div>Not logged in</div>;
  }
}
Authenticator.propTypes = {
  children: PropTypes.object,
};
export default Authenticator;
